import type { PublicTelemetry } from './events';
import { redactSensitiveString } from '../security/redaction';

export function reportRuntimeError(
  telemetry: PublicTelemetry,
  pageId: string,
  error: unknown,
): void {
  const message = error instanceof Error ? error.message : String(error);
  telemetry.emit({
    name: 'public_runtime_error',
    pageId,
    ok: false,
    context: {
      message: redactSensitiveString(message),
      stackIncluded: false,
      fullLocationHrefIncluded: false,
    },
  });
}
